import { Table } from "@mantine/core";
import type { EmpresaMedia } from "@/routes/relatorio-page/RelatorioLayout";

const getPorte = (porte: string | undefined) => {
  if (porte === "MICRO_EMPREENDEDOR") return "Empreendedor";
  if (porte === "MICRO_EMPRESA") return "Micro Empresa";
  if (porte === "EMPRESA_PEQUENO_PORTE") return "Pequeno Porte";
  if (porte === "EMPRESA_MEDIO_PORTE") return "Médio Porte";
  if (porte === "EMPRESA_GRANDE_PORTE") return "Grande Porte";
  return porte;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
// prettier-ignore
const TableMediaItem = ({ item }: { item: EmpresaMedia }) => {
  return (
    <Table.Tr key={item?.nomeFantasia}>
      <Table.Td>{item?.nomeFantasia}</Table.Td>
      <Table.Td>{item?.cnpj}</Table.Td>
      <Table.Td>{item?.responsavel.nome}</Table.Td>
      <Table.Td>{item?.responsavel?.telefone}</Table.Td>
      <Table.Td>{getPorte(item?.porte ?? undefined)}</Table.Td>
      <Table.Td>{item?.endereco?.estado}</Table.Td>
      <Table.Td>{item?.categorias}</Table.Td>
      <Table.Td>{item?.media}</Table.Td>
      <Table.Td>{item?.oficial}</Table.Td>
      <Table.Td>{item?.fase}</Table.Td>
    </Table.Tr>
  )
};

export default TableMediaItem;
